import SvgIcon from '@mui/material/SvgIcon'

const AIRefineIcon = () => (
  <SvgIcon
    viewBox="0 0 14 14"
    sx={{
      width: 14,
      height: 14,
    }}>
    <path
      d="M7.9988 6.00353L10.9087 7.07557C11.1316 7.15777 11.324 7.30635 11.4599 7.50127C11.5958 7.69619 11.6686 7.92808 11.6686 8.16569C11.6686 8.4033 11.5958 8.63519 11.4599 8.83011C11.324 9.02504 11.1316 9.17361 10.9087 9.25581L7.99647 10.3302L6.92443 13.2401C6.84223 13.463 6.69365 13.6554 6.49873 13.7913C6.30381 13.9272 6.07192 14 5.83431 14C5.5967 14 5.36481 13.9272 5.16989 13.7913C4.97497 13.6554 4.82639 13.463 4.74419 13.2401L3.66982 10.3278L0.759916 9.25581C0.53698 9.17361 0.344606 9.02504 0.208728 8.83011C0.0728496 8.63519 0 8.4033 0 8.16569C0 7.92808 0.0728496 7.69619 0.208728 7.50127C0.344606 7.30635 0.53698 7.15777 0.759916 7.07557L3.67215 6.00353L4.74419 3.0913C4.82639 2.86836 4.97497 2.67599 5.16989 2.54011C5.36481 2.40423 5.5967 2.33138 5.83431 2.33138C6.07192 2.33138 6.30381 2.40423 6.49873 2.54011C6.69365 2.67599 6.84223 2.86836 6.92443 3.0913L7.9988 6.00353Z"
      fill="url(#paint0_linear_1175_8609)"
    />
    <path
      d="M7.67245 1.60483C7.54119 1.73609 7.46745 1.91412 7.46745 2.09975C7.46745 2.28538 7.54119 2.46341 7.67245 2.59466C7.80371 2.72592 7.98173 2.79967 8.16736 2.79967H8.86728V3.49958C8.86728 3.68521 8.94102 3.86324 9.07228 3.9945C9.20354 4.12576 9.38157 4.1995 9.5672 4.1995C9.75283 4.1995 9.93085 4.12576 10.0621 3.9945C10.1934 3.86324 10.2671 3.68521 10.2671 3.49958V2.79967H10.967C11.1527 2.79967 11.3307 2.72592 11.4619 2.59466C11.5932 2.46341 11.6669 2.28538 11.6669 2.09975C11.6669 1.91412 11.5932 1.73609 11.4619 1.60483C11.3307 1.47357 11.1527 1.39983 10.967 1.39983H10.2671V0.699916C10.2671 0.514287 10.1934 0.336261 10.0621 0.205001C9.93085 0.073741 9.75283 0 9.5672 0C9.38157 0 9.20354 0.073741 9.07228 0.205001C8.94102 0.336261 8.86728 0.514287 8.86728 0.699916V1.39983H8.16736C7.98173 1.39983 7.80371 1.47357 7.67245 1.60483Z"
      fill="url(#paint1_linear_1175_8609)"
    />
    <path
      d="M13.795 5.39433C13.9263 5.26307 14 5.08504 14 4.89941C14 4.71379 13.9263 4.53576 13.795 4.4045C13.6637 4.27324 13.4857 4.1995 13.3001 4.1995H13.0668V3.96619C13.0668 3.78056 12.993 3.60254 12.8618 3.47128C12.7305 3.34002 12.5525 3.26628 12.3669 3.26628C12.1812 3.26628 12.0032 3.34002 11.8719 3.47128C11.7407 3.60254 11.6669 3.78056 11.6669 3.96619V4.1995H11.4336C11.248 4.1995 11.07 4.27324 10.9387 4.4045C10.8075 4.53576 10.7337 4.71379 10.7337 4.89941C10.7337 5.08504 10.8075 5.26307 10.9387 5.39433C11.07 5.52559 11.248 5.59933 11.4336 5.59933H11.6669V5.83264C11.6669 6.01827 11.7407 6.19629 11.8719 6.32755C12.0032 6.45881 12.1812 6.53255 12.3669 6.53255C12.5525 6.53255 12.7305 6.45881 12.8618 6.32755C12.993 6.19629 13.0668 6.01827 13.0668 5.83264V5.59933H13.3001C13.4857 5.59933 13.6637 5.52559 13.795 5.39433Z"
      fill="url(#paint2_linear_1175_8609)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1175_8609"
        x1="10"
        y1="3"
        x2="0.614925"
        y2="3.33899"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7575D7" />
        <stop offset="0.988684" stopColor="#C472B7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1175_8609"
        x1="10"
        y1="3"
        x2="0.614925"
        y2="3.33899"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7575D7" />
        <stop offset="0.988684" stopColor="#C472B7" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1175_8609"
        x1="10"
        y1="3"
        x2="0.614925"
        y2="3.33899"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#7575D7" />
        <stop offset="0.988684" stopColor="#C472B7" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

export default AIRefineIcon
